export const CARD_DND_TYPE = 'CARD';
export const COLUMN_DND_TYPE = 'COLUMN';
export const TRANSITION_ZONE_DND_TYPE = 'TRANSITION_ZONE';
